import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/styles/index.scss'
import { Button, Select, Form, FormItem, Table, Input, Pagination, Option, Checkbox, DatePicker, TableColumn, Icon, Loading } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import store from './store'
import { $Message  } from '@/utils/message'

// import 'swiper/css/swiper.css'

Vue.config.productionTip = false
Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Checkbox)
Vue.use(DatePicker)
Vue.use(Icon)
Vue.use(Loading)
// Vue.component(Message)
Vue.use(Input)
Vue.use(Pagination)
Vue.use(VueAwesomeSwiper)
Vue.prototype.$message = $Message
new Vue({
  router,
  render: h => h(App),
  store
}).$mount('#app')
